var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEmail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.86779 3.76382C1.97062 3.42011 2.29131 3.16663 2.66663 3.16663H13.3333C13.7086 3.16663 14.0293 3.42011 14.1321 3.76382L7.99996 8.05634L1.86779 3.76382ZM0.833313 3.99173C0.833238 3.99653 0.833232 4.00133 0.833295 4.00612V12C0.833295 13.0094 1.65715 13.8333 2.66663 13.8333H13.3333C14.3428 13.8333 15.1666 13.0094 15.1666 12V4.00611M14.1666 4.96033V12C14.1666 12.4572 13.7905 12.8333 13.3333 12.8333H2.66663C2.20944 12.8333 1.83329 12.4572 1.83329 12V4.96033L7.71323 9.07628C7.88539 9.19679 8.11453 9.19679 8.28669 9.07628L14.1666 4.96033ZM15.1666 3.99175C15.1622 2.98602 14.34 2.16663 13.3333 2.16663H2.66663C1.6599 2.16663 0.837774 2.98601 0.833313 3.99173",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/email.fbd7fb93.svg";
export { ForwardRef as ReactComponent };